module.exports = __webpack_public_path__ + "img/file.f93a9da3.svg";